export enum LocalStorageID {
    Banner = 'banner',
    Columns = 'columns',
    Disclaimer = 'disclaimer',
    MaintenanceNotification = 'maintenanceNotification',
    ReadExportOnlyNotification = 'readExportOnlyNotification',
    ViewOptions = 'viewOptions',
    ExportOptions = 'exportOptions',
    Overviews = 'overviews'
}

export const LOCAL_STORAGE_TO_PRESERVE: LocalStorageID[] = [
    LocalStorageID.Columns,
    LocalStorageID.Disclaimer,
    LocalStorageID.ViewOptions,
    LocalStorageID.ExportOptions,
    LocalStorageID.Overviews
];
